var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"misc",attrs:{"aria-label":_vm.iconAlt},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('callback')}}},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.iconAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }